module.exports = __webpack_public_path__ + "img/hr-H-T-2-unload-standup-shadow.322cece1.png";